import React from 'react';
import { Row, Col } from 'antd';

import { LoadRecruiterDetailsOptions } from 'features/recruiter/RecruiterDetailsPage/types';
import GeneralInfoSection from './GeneralInfoSection';
import PricingAgreementSection from './PricingAgreementSection';
import EntityInfoSection from './EntityInfoSection';
import BankingInfoSection from './BankingInfoSection';
import {
  FullBOUserResponseModel,
  ResourceDownloadResponse,
  EntityInformationResponseModel,
} from 'api/backofficeApiClient';

type Props = {
  recruiterDetails: FullBOUserResponseModel;
  entityInfo?: EntityInformationResponseModel;
  entityInfoFile?: ResourceDownloadResponse;
  bankingInfoFile?: ResourceDownloadResponse;
  loadRecruiterDetails: (
    options?: LoadRecruiterDetailsOptions,
  ) => Promise<void>;
};

export default function RecruiterPrimaryInfoSection(props: Props) {
  const {
    entityInfo,
    recruiterDetails,
    entityInfoFile,
    loadRecruiterDetails,
    bankingInfoFile,
  } = props;

  return (
    <Row gutter={[10, 10]}>
      <Col xs={24} md={12} className="d-flex">
        <GeneralInfoSection
          recruiterDetails={recruiterDetails}
          loadRecruiterDetails={loadRecruiterDetails}
        />
      </Col>

      <Col xs={24} md={12} className="d-flex">
        <PricingAgreementSection
          recruiterDetails={recruiterDetails}
          loadRecruiterDetails={loadRecruiterDetails}
        />
      </Col>

      <Col xs={24} md={12} className="d-flex">
        <EntityInfoSection
          entityInfoFile={entityInfoFile}
          recruiterDetails={recruiterDetails}
          loadRecruiterDetails={loadRecruiterDetails}
        />
      </Col>

      <Col xs={24} md={12} className="d-flex">
        <BankingInfoSection
          bankingInfoFile={bankingInfoFile}
          entityInfo={entityInfo}
          recruiterDetails={recruiterDetails}
          loadRecruiterDetails={loadRecruiterDetails}
        />
      </Col>
    </Row>
  );
}
